import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../components/global/DynamicIcon";
import dataUtils from "../../../../../../common/utils/dataUtils";
import LargeItemStatus from "../../../../../../common/components/large_item_status";

type Props = {
  onActionEditar: (id: number | null, openState: boolean) => void;
  onActionDeletar: (id: number | null, openState: boolean) => void;
};

export const GenerateProjetoImpressaoColumnDefinition = ({ onActionEditar, onActionDeletar }: Props): GridColDef[] => {
  const computeStatusDescription = (status: number) => {
    switch (status) {
      case 0:
        return "Pendente";
      case 1:
        return "Aprovado";
      case 2:
        return "Reprovado";
      default:
        return "Desconhecido";
    }
  };

  const computeStatusColor = (status: number) => {
    switch (status) {
      case 0:
        return "yellow";
      case 1:
        return "green";
      case 2:
        return "red";
      default:
        return "gray";
    }
  };

  return [
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus title={computeStatusDescription(params.value)} color={computeStatusColor(params.value)} description="" />
        </div>
      ),
    },
    {
      field: "statusEmail",
      headerName: "Email Enviado?",
      flex: 1,
      minWidth: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => <div className="w-full h-full flex justify-center items-center">{params.value === 1 ? "Sim" : "Não"}</div>,
    },
    {
      field: "projeto",
      headerName: "Projeto",
      flex: 1,
      minWidth: 200,
      sortable: false,
      filterable: false,
    },
    {
      field: "centroCusto",
      headerName: "Centro de Custo",
      flex: 1,
      minWidth: 180,
      sortable: false,
      filterable: false,
    },
    {
      field: "dataSolicitacao",
      headerName: "Data Solicitação",
      flex: 1,
      minWidth: 160,
      sortable: false,
      filterable: false,
      valueGetter: (params) => dataUtils.dataFormatada(params),
    },
    {
      field: "solicitante",
      headerName: "Solicitante",
      flex: 1,
      minWidth: 200,
      sortable: false,
      filterable: false,
    },
    {
      field: "dataAprovacao",
      headerName: "Data Aprovação/Reprovação",
      flex: 1,
      minWidth: 200,
      sortable: false,
      filterable: false,
      valueGetter: (params) => dataUtils.dataFormatada(params),
    },
    {
      field: "aprovador",
      headerName: "Responsável Aprovação",
      flex: 1,
      minWidth: 220,
      sortable: false,
      filterable: false,
    },
    {
      field: "idProjetoImpressao",
      headerName: "	Visualizar",
      width: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.row.idProjetoImpressao, true)}>
            <DynamicIcon nameIcon="Visibility" size={25} className="text-yellow-500" />
          </IconButton>
        </div>
      ),
    },
  ];
};
